<template>
    <div>
        <modal-share-house class="eval-comment-modal" :display="modalStatus.evaluationCommentModal" @modalStatus="closeModal" >
            <div class="eval-comment-modal-wrap">
                <div class="content">
                    <div class="evaluation-count">
                        <div class="title-group">
                            <h1 class="title">全部評價</h1>
                            <div class="all-count">
                                ({{rateCommentTotal}}個真實房客的評價)
                            </div>
                        </div>
                        <div class="evaluation">
                            <div class="average-eval">
                                <div class="average">
                                    {{rateAverage.toFixed(1)}}
                                </div>
                                <div ref="stars" class="stars">
                                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                                </div>
                            </div>
                            <div class="bar-chart">
                                <ul>
                                    <li>
                                        5
                                        <div class="bar-group">
                                            <div class="bar bg-bar"></div>
                                            <div class="bar percent-bar" :style="'width:'+getRatePercent(4)+'%'"></div>
                                        </div>
                                    </li>
                                    <li>
                                        4
                                        <div class="bar-group">
                                            <div class="bar bg-bar"></div>
                                            <div class="bar percent-bar" :style="'width:'+getRatePercent(3)+'%'"></div>
                                        </div>
                                    </li>
                                    <li>
                                        3
                                        <div class="bar-group">
                                            <div class="bar bg-bar"></div>
                                            <div class="bar percent-bar" :style="'width:'+getRatePercent(2)+'%'"></div>
                                        </div>
                                    </li>
                                    <li>
                                        2
                                        <div class="bar-group">
                                            <div class="bar bg-bar"></div>
                                            <div class="bar percent-bar" :style="'width:'+getRatePercent(1)+'%'"></div>
                                        </div>
                                    </li>
                                    <li>
                                        1
                                        <div class="bar-group">
                                            <div class="bar bg-bar"></div>
                                            <div class="bar percent-bar" :style="'width:'+getRatePercent(0)+'%'"></div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="comment-wrap">
                        <div class="item" v-for="(item, index) in comments" :key="index">
                            <div class="shot-wrap">
                                <div class="shot">
                                    <img v-if="item.avatarUrl" class="shot-img" :src="imageUrl(item.avatarUrl)" alt="">
                                    <img v-else class="shot-img" src="@/assets/img/shareHouse/shot.svg" alt="">
                                    <!-- <img class="award" src="@/assets/img/shareHouse/award.svg" alt=""> -->
                                </div>
                            </div>
                            <div class="comment-group">
                                <div class="name">
                                    {{item.tenantName}}
                                </div>
                                <div class="eval-and-date">
                                    <div class="star">
                                        <img src="@/assets/img/shareHouse/star_orange.svg" alt="">
                                        {{item.rate}}
                                    </div>
                                    <div class="contract-date">
                                        {{getFormatDate(item.contractBeginTime)}}-{{getFormatDate(item.contractEndTime)}}
                                    </div>
                                </div>
                                <div class="comment">
                                    {{item.comment}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal-share-house>
    </div>
</template>
<script>
import ModalShareHouse from '@/components/widge/ModalShareHouse.vue';
import { mapGetters } from 'vuex'
import { 
        baseDomain,
    } from "@/apis/api.js"; 
export default {
    mounted() {
        this.setStars()
    },
     watch: {
        rateAverage: {
            handler: function (val) {
                this.setStars()
            },
        }
    },
    methods: {
        setStars: function () {
            if(this.$refs.stars.children){
                let stars = this.$refs.stars.children
                for (let i = 0; i < this.rateAverage; i++) {
                    const star = stars[i];
                    star.src = require('../../assets/img/shareHouse/star_orange.svg')
                }
            }
        },
        getRatePercent: function (index) {
            let rateCount = this.rateCountList[index].rateCount
            let heightestRate = this.heightestRate.count

            return (rateCount/heightestRate) * 100
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'evaluationCommentModal'})
        },
        imageUrl: function (url) {
            return baseDomain+url
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'年'+formatDate[5]+'月';
        },
    },
    computed: {
        heightestRate: function () {
            let maxCount = 0
            let MaxRateStar = 0

            this.rateCountList.map( item => {
                // console.log(item)
                if( item.rateCount > maxCount){
                    maxCount = item.rateCount
                    MaxRateStar = item.rate
                }
            })
            return { 'star': MaxRateStar, 'count': maxCount}
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            rateAverage: 'GET_SHARE_HOUSE_RATE_AVERAGE',
            rateCommentTotal: 'GET_SHARE_HOUSE_RATE_COMMENT_TOTAL',
            rateCountList: 'GET_SHARE_HOUSE_RATE_COUNT_LIST',
            comments: 'GET_SHARE_HOUSE_RATE_COMMENT',
        })
    },
    components: {
        ModalShareHouse,
    }
}
</script>
<style lang="scss" scoped>
    #modal.eval-comment-modal{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 780px;
            height: 520px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .eval-comment-modal-wrap{
                    padding: 0 32px 0 32px;
                    .content{
                        .evaluation-count{
                            width: 780px;
                            margin-top: 40px;
                            padding-bottom: 24px;
                            border-bottom: 1px solid  #d7d9db;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            .title-group{
                                width: 670px;
                                display: flex;
                                align-items: center;
                                margin-bottom: 23px;
                                h1.title{
                                    font-size: 22px;
                                    font-weight: 500;
                                    line-height: 1.47;
                                    margin-right: 12px;
                                    color: #3a455f;
                                }
                                .all-count{
                                    font-size: 20px;
                                    color: #909090;
                                }
                            }
                            .evaluation{
                                width: 670px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .average-eval{
                                    width: 84px;
                                    .average{
                                        font-size: 50px;
                                        font-weight: 500;
                                        margin-bottom: 12px;
                                    }
                                    .stars{
                                        img{
                                            width: 14px;
                                        }
                                    }
                                }
                                .bar-chart{
                                    width: 81.81%;
                                    ul{
                                        li{
                                            position: relative;
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-between;
                                            font-size: 16px;
                                            font-weight: 500;
                                            margin-bottom: 3px;
                                            .bar-group{
                                                position: relative;
                                                width: 96.34%;
                                                .bar{
                                                    width: 100%;
                                                    height: 6px;
                                                    border-radius: 3px;
                                                    background-color: #dfdfdf;
                                                }
                                                .bg-bar{
                                                    position: absolute;
                                                    z-index: 1;
                                                }
                                                .percent-bar{
                                                    position: relative;
                                                    z-index: 2;
                                                    background-color: #ff9275;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .comment-wrap{
                            position: relative;
                            display: flex;
                            align-items: center;
                            flex-direction: column;
                            height: 295px;
                            overflow-x: hidden;
                            .item{
                                display: flex;
                                justify-content: space-between;
                                width: 670px;
                                padding-top: 25px;
                                .comment-group{
                                    width: 87.65%;
                                    font-size: 16px;
                                    border-bottom: 0;
                                    padding-bottom: 0px;
                                    .name{
                                        margin-bottom: 12px;
                                    }
                                    .eval-and-date{
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 20px;
                                        .star{
                                            position: relative;
                                            display: flex;
                                            align-items: center;
                                            margin-right: 23px;
                                            img{
                                                width: 14px;
                                                margin-right: 6px;
                                            }
                                        }
                                        .star::after{
                                            content: '';
                                            position: absolute;
                                            width: 1px;
                                            height: 10px;
                                            background: #979797;
                                            right: -12px;
                                        }
                                        .contract-date{
                                            color: #909090;
                                        }
                                    }
                                    .comment{
                                        font-size: 14px;
                                        line-height: 1.5;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/evaluationCommentModal.vue